/**
 * 申请处理页懒加载壳（14.20；ContactSearchLazy 同构）：低频页不进首屏 bundle。
 */
import { useLazyModule } from './useLazyModule';
import type { ApplyKind } from '~/chat/applyModel';

export function ContactApplyLazy({ kind }: { kind: ApplyKind }) {
  const { mod } = useLazyModule(() => import('./ContactApplyPage'));
  if (mod === null) return <div data-testid="contact-apply-loading-shell">加载中…</div>;
  return <mod.ContactApplyPage kind={kind} />;
}
